import { Component } from '@angular/core';

@Component({
    selector: 'marg-id-info',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class MargIdInfoComponent {}
